var React = require('react');

function CheckboxEmptyInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"13","height":"13","rx":"5","fill":"#7F919B","key":0}),React.createElement("circle",{"cx":"6.5","cy":"6.5","r":"4.5","fill":"white","key":1})]);
}

CheckboxEmptyInline.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = CheckboxEmptyInline;

CheckboxEmptyInline.default = CheckboxEmptyInline;
